export const removeOptionIconStyle = (img) => {
  return {
    background: `url(${img}) right center / 24px no-repeat`,
    cursor: "pointer",
    display: "block",
    height: "28px",
    width: "28px",
  };
};

export const iconWrapperStyle = () => {
  return {
    width: "50px",
  };
};
